import BaseReducer from "../../utilities/BaseReducer";
import InfluencerUserAction from "./InfluencerUserAction";

export default class InfluencerUserByIdReducer extends BaseReducer {
  //initial state of user
  initialState = {
    influencerUserById: [],
  };

  //user request action finish
  [InfluencerUserAction.REQUEST_USER_BY_ID_FINISHED](state, action) {
    return {
      ...state,
      influencerUserById: action.payload,
    };
  }
}
